module.exports = __webpack_public_path__ + "img/cgd5.927c827b.jpg";